import DeviceLoanApprovalTable from "./ApprovalTable";

const BranchDeviceLoanApproval = () => <DeviceLoanApprovalTable level="branch" />;

export default BranchDeviceLoanApproval;
